import { IStore } from 'store/configureStore';

export const employmentState = (state: IStore) => state.modules.employment;
